import React from 'react';

const steps = [
  {
    number: 1,
    title: 'Enter or Translate',
    icon: '🌍',
    bg: 'bg-blue',
  },
  {
    number: 2,
    title: 'Save as Flashcard',
    icon: '📘',
    bg: 'bg-purple',
  },
  {
    number: 3,
    title: 'Practice via Quiz',
    icon: '🧠',
    bg: 'bg-green',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-gray px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-blue mb-2">
  How it works?
</h2>
<p className="text-charcoal text-lg md:text-xl mb-20">
  A simple process designed for effective language learning.
</p>

        <div className="flex flex-col sm:flex-row sm:justify-center items-center sm:items-end relative">
          {steps.map((step, idx) => (
            <div
              key={step.number}
              className={`
                relative rounded-full w-52 h-52 sm:w-60 sm:h-60 flex flex-col items-center justify-center text-gray mx-[-10px] sm:mx-0
                ${step.bg}
                ${idx === 1 ? 'mt-[-40px] sm:mb-10 sm:ml-[-30px]' : ''}
                ${idx === 2 ? 'mt-[-46px] sm:mb-20 sm:ml-[-60px]' : ''}
                shadow-xl
              `}
            >
              <div className="text-4xl mb-2">{step.icon}</div>
              <div className="text-2xl font-bold">Step {step.number}</div>
              <p className="text-sm mt-1 px-4 text-center">{step.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
